import TestFeature from './custom-m.js'

import Vue from 'vue'
import Router from 'vue-router'
import VueI18n from 'vue-i18n'
import VuePlyr from 'vue-plyr'

import videobg from 'vue-videobg'


import messages from './localizations/messages'

import home from './components/home'
import contact from './components/contact'
import preloader from './components/preloader'
import layout from './components/layout'
import player from './components/player'


import app from './app'

import './assets/scss/app.scss' 

Vue.use(Router)
Vue.use(VuePlyr)
Vue.use(VueI18n)

if (location.hostname === 'localhost') {
  Vue.config.productionTip = false;
  Vue.config.debug = true
  window._ = Vue.util
}

export const EventBus = new Vue();

const routes = [
    {
      path: '/',
      component: home
    },
    {
      path: '/contact',
      component: contact
    }
  ]

const router = new Router({
  mode: 'history',
  routes
})

const i18n = new VueI18n({
  locale: 'en', 
  messages,
})

Vue.component('video-bg', videobg)
Vue.component('preloader', preloader)
Vue.component('layout', layout)
Vue.component('player', player)

const vm = new Vue({
  el: '#app',
  render: h => h(app),
  i18n,
  router
})

export {i18n, router}


// WEBPACK FOOTER //
// ./src/main.js